"use client";

import { BEJWTPayload, PXSession } from "@/types/session";
import decodeSessionCookie from "@/utils/decodeSessionCookie";
import { getCookie } from "cookies-next";
import { jwtDecode } from "jwt-decode";
import { useEffect, useState } from "react";

export default function useSession() {
  const [session, setSession] = useState<PXSession>();

  useEffect(() => {
    const sessionCookie = getCookie("session");
    const decodedSession = decodeSessionCookie(sessionCookie);
    const user = decodedSession?.id_token
      ? jwtDecode<BEJWTPayload>(decodedSession?.id_token)
      : undefined;

    setSession(
      user
        ? {
            accessToken: decodedSession?.access_token || "",
            email: user.email,
            role: decodedSession?.role,
          }
        : undefined,
    );
  }, []);

  return session;
}
